import { ICandidate } from '@/shared/api-client/models/candidate';
import { ICandidateUserData } from '@/shared/api-client/models/candidate-user-data';
import { ICandidateTransport } from '@/shared/api-client/models/election/candidate-transport';
import _ from 'lodash';

export class CandidateMapper {

    public static toCandidate(candidates: ICandidateTransport[], userIdDisabledBySelfVoting?: string): ICandidate[] {

        return _.map(candidates, c => {

            const userData: ICandidateUserData = {};

            if (c.ud !== undefined) {

                if (c.ud.id !== undefined) {
                    userData.id = c.ud.id;
                }

                if (c.ud.pfn !== undefined) {
                    userData.pictureFileName = c.ud.pfn;
                }

                if (c.ud.g !== undefined) {
                    userData.gender = c.ud.g;
                }
            }

            return {
                id: c.i,
                type: c.t,
                displayName: c.n,
                description: c.d,
                nominatedByCommittee: c.nc || false,
                isFavorite: c.fav || false,
                disabledByNoSelfVoting: (userIdDisabledBySelfVoting && userData.id === userIdDisabledBySelfVoting) ? true : (c.dsv || false),
                userData,
                filterableProperties: c.fp
            } as ICandidate;
        });
    }
}
